import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AISearch.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AISearch = ({ aiSearchContent = {} }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            offset: 100,
        });

        // Check if device is mobile
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        arrows: !isMobile,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    dots: true,
                    autoplay: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    swipeToSlide: true,
                    touchThreshold: 5
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    dots: true,
                    autoplay: true,
                    autoplaySpeed: 3500,
                    speed: 400,
                    width: '100%',
                    swipeToSlide: true,
                    touchThreshold: 3
                }
            }
        ]
    };

    const renderSlideContent = (section, idx) => {
        const isLeftImage = section.imagePosition === 'left';
        
        return (
            <div className="slide-item" key={idx}>
                <div className="slide-content">
                    <div className="slide-header">
                        <h2>{section.title}</h2>
                        <p className="slide-description">{section.description}</p>
                    </div>
                    
                    <div className="slide-body">
                        {isLeftImage ? (
                            <>
                                <div className="slide-visual" data-aos="fade-right" data-aos-delay="200">
                                    <img 
                                        src={section?.image} 
                                        alt={section.title} 
                                        className='img-fluid'
                                        loading="lazy"
                                    />
                                </div>
                                
                                <div className="slide-features" data-aos="fade-left" data-aos-delay="400">
                                    <h3>Key Features:</h3>
                                    <ul className="features-list">
                                        {section.features.map((feature, i) => (
                                            <li key={i}>
                                                <span className="feature">{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="slide-features" data-aos="fade-right" data-aos-delay="200">
                                    <h3>Key Features:</h3>
                                    <ul className="features-list">
                                        {section.features.map((feature, i) => (
                                            <li key={i}>
                                                <span className="feature">{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                
                                <div className="slide-visual" data-aos="fade-left" data-aos-delay="400">
                                    <img 
                                        src={section?.image} 
                                        alt={section.title} 
                                        className='img-fluid'
                                        loading="lazy"
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="education-solutions">
            <div className="container">
                <h1 className="main-title text-center mb-5" data-aos="fade-up">
                    {aiSearchContent.mainTitle}
                </h1>
                
                <div className="slider-container">
                    <Slider {...sliderSettings}>
                        {aiSearchContent.sections && aiSearchContent.sections.map((section, idx) => 
                            renderSlideContent(section, idx)
                        )}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default AISearch; 